export const HelpChatLink = "https://tawk.to/accredmedia";
